import { render, staticRenderFns } from "./DownloadOptions.vue?vue&type=template&id=23e108a3&scoped=true&"
import script from "./DownloadOptions.vue?vue&type=script&lang=js&"
export * from "./DownloadOptions.vue?vue&type=script&lang=js&"
import style0 from "./DownloadOptions.vue?vue&type=style&index=0&id=23e108a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e108a3",
  null
  
)

export default component.exports